<script  lang="ts" setup="">
import type { NavItemProps } from '~/utils/nav'
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons'
import { DropdownMenuContent, DropdownMenuItem, DropdownMenuRoot, DropdownMenuTrigger } from 'reka-ui'

defineProps<NavItemProps>()

const { theme } = useTheme()
</script>

<template>
  <div class="relative z-10 text-primary">
    <DropdownMenuRoot v-slot="{ open }" :data-dd-privacy="privacy">
      <DropdownMenuTrigger :data-dropdown-trigger="open ? 'open' : 'closed'" as-child>
        <NavButton
          :privacy="privacy"
          :icon="icon"
          :label="label"
          :open="open"
          class="pointer-events-auto"
          :class="{
            'text-[--text]': !open,
            'dark:[--active-bg:theme(colors.moss.200)]': open && theme === 'moss',
            'dark:text-carbon-50 hover:dark:text-carbon-50': open && theme === 'carbon',
          }"
        >
          <Icon :icon="faChevronDown" :class="{ 'rotate-180': open }" class="transition-transform duration-100" size="sm" />
        </NavButton>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="start" class="z-[-1] rounded-xl shadow-menu bg-surface-elevated dark:text-carbon-500 data-[state=open]:animate-[scale-in_100ms_ease-out] data-[state=closed]:animate-[scale-out_100ms_ease-in] origin-[--reka-dropdown-menu-content-transform-origin]">
        <DropdownMenuItem
          v-for="item in childProps"
          :key="item.label"
          class="rounded-none [&:not(:first-of-type)]:border-t [&:not(:first-of-type)]:border-carbon-100"
        >
          <NavButton
            v-bind="item"
            :on-click="item.onClick"
            :icon="undefined"
            :class="{
              'dark:[--active-bg:theme(colors.moss.200)]': theme === 'moss',
              'hover:dark:text-carbon-50': open && theme === 'carbon',
            }"
          />
        </DropdownMenuItem>

        <DropdownMenuItem v-if="slots?.post" as-child>
          <component :is="slots.post" class="mt-s w-full" :class="{ 'dark-mode': theme === 'blurple' }" />
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenuRoot>
  </div>
</template>

<style scoped>
:deep([data-reka-popper-content-wrapper]) {
  --_padding: theme('spacing.s');
  --_offset-y: calc(var(--_padding) + var(--reka-popper-anchor-height, 0));

  left: calc(-1 * var(--_padding)) !important;
  top: calc(-1 * var(--_offset-y)) !important;

  [data-reka-menu-content] {
    padding: var(--_padding);
    padding-top: calc(var(--_padding) + var(--_offset-y));
  }
}
</style>
